import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_43: FaireProductEntity = {
  token: "catalog_prod_prod-43",
  type: "product",
  name: "Ascent Deco Sculpture",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=400&fit=crop",
  priceDollars: 70.24,
  msrpDollars: 175.6,
  sku: "JA0043",
  caseSize: 6,
  material: "Glass",
  collectionToken: "col_japandi",
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 238,
  description: "Beautiful Japandi piece perfect for any home.",
  categoryTokens: ["catalog_cat_home-fragrances"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
